import React, { useState, useEffect } from 'react';
import * as FieldTypes from "./FieldTypes.js";

const DeviceCount = ({
    UDI,
    setUDI,
    fieldTitle = "Device Count",
    fieldName = "DeviceCount",
    forceIsEditing = null
}) => {

    const [errorVar, setErrorVar] = useState(false);
    const [isEditingField, setIsEditingField] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [value, setValue] = useState(UDI?.[fieldName]);

    const handleChange = (e) => {
        let newValue = e.target.value;
        setValue(newValue);
        
        setUDI(prevItem => ({
            ...prevItem,
            [fieldName]: newValue
        }));

        validate(newValue);
    }


    const validate = (newValue) => {

        setErrorVar(null);

        if (newValue === "") {
            setErrorVar("The Device Count field is required.");
            return;
        }

        if (isNaN(newValue)) {
            setErrorVar("The Device Count field must be numeric.");
            return;
        }

        if (parseInt(newValue) < 0 || parseInt(newValue) > 9999999) {
            setErrorVar("Device Count must be 0 or lower than 9999999.");
            return;
        }

    }


    
    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);


    useEffect(() => {

        validate(value);

    }, [value]);
    
    

    return (
        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">


                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                        <div>
                            {isEditingField === false ? (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span
                                            className={`editable-field-span ${errorVar ? "form-field-error" : ""}`}
                                            onClick={() => changeIsEditingField(true)}
                                        >
                                            {value === "" ?
                                                <FieldTypes.ItemDetailsField_EmptyValue />
                                                :
                                                value
                                            }
                                        </span>
                                    </div>

                                </div>
                            ) : (
                                <span>
                                    <input
                                        className="form-control"
                                        onBlur={() => changeIsEditingField(false)}
                                        onChange={handleChange}
                                        value={value}
                                        autoFocus={forceIsEditing != null ? false : true}
                                    />
                                </span>
                            )}
                        </div>
                        <div>
                            {errorVar && (
                                <span className="form-field-error-message">
                                    {errorVar}
                                </span>
                            )}
                        </div>
                    </div>

                    

                </div>
            </div>
        </div>
    );
}

export default DeviceCount;